import axios from "axios";
import { attachAuthHeader } from "@/config/axios";
import { setupAxiosRetry } from "@/utils/axiosRetry";

const aiBackendApi = axios.create({
  baseURL: import.meta.env.VITE_AI_BACKEND_URL,
  // ipponApi と同様、Lambda コールドスタートで初回が落ちる問題対策。
  // timeout で ECONNABORTED 化 → axiosRetry が指数バックオフで自動リトライ。
  timeout: 30_000,
});

setupAxiosRetry(aiBackendApi, {
  maxAttempts: 3,
  baseDelay: 1000,
  maxDelay: 10000,
});

// ipponApi と同じく、期限切れ間近の token は送信前にリフレッシュする。
// (期限切れ token のまま送って初回だけ 401 になるのを防ぐ)
aiBackendApi.interceptors.request.use(attachAuthHeader, (error) =>
  Promise.reject(error)
);

export default aiBackendApi;
